<div class="wrapper">

  <div class="title">{{'panel.home.title.general' | translate }}</div>

  @if (enableHome) {
    <tun-recommendations-view class="recommendationsContainer">
    </tun-recommendations-view>
  }
</div>
